<template>
  <div class="logreg">
    <logregnav />
    <router-view />
    <lv-footer />
  </div>
</template>

<script>
import logregnav from "./child/logregnav";
import lvFooter from "../../components/content/lvFooter/lvFooter";
export default {
  components: {
    logregnav,
    lvFooter,
  },
};
</script>

<style lang="scss" scoped>
.logreg {
  width: 100%;
}
</style>